// https://docs.developers.optimizely.com/full-stack/docs/javascript-browser
// https://github.com/Gusto/gusto-analytics/pull/185/files
// https://github.com/Gusto/gusto-analytics/blob/master/documentation/WALKTHROUGH.md

const optimizelySDK = require('@optimizely/optimizely-sdk');

// This class implements a GustoAnalytics provider for Optimizely FullStack. If Optimizely FS is proved successful, this
// implementation will be moved into GustoAnalytics
class OptimizelyFullStackClientSDK {
  constructor(client) {
    this.client = client;
  }

  processQueue() {
    window.optimizelyConfigFS.queue.forEach(element => {
      this.track(element[0]);
    });

    window.optimizelyConfigFS.queue = [];
  }

  track(opts = {}) {
    this.client.track(
      `${opts.eventCategory}-${opts.eventName}`,
      window.optimizelyConfigFS.visitor_id,
      opts.data,
      opts.data
    );
  }

  isFeatureEnabled(name) {
    return this.client.isFeatureEnabled(name, window.optimizelyConfigFS.visitor_id);
  }

  getFeatureVariable(name, variable) {
    return this.client.getFeatureVariable(name, variable, window.optimizelyConfigFS.visitor_id);
  }
}

const optimizelyClientInstance = optimizelySDK.createInstance({
  sdkKey: window.optimizelyConfigFS.key,
  datafileOptions: {
    autoUpdate: true,
    updateInterval: window.optimizelyConfigFS.polling_interval_in_seconds * 1000, // in milliseconds
  },
});

// Provide a timeout in milliseconds - promise will resolve if the datafile still is not available after the timeout
optimizelyClientInstance
  .onReady({ timeout: window.optimizelyConfigFS.blocking_timeout })
  .then(result => {
    if (!result.success) {
      console.error(result.reason);
      return;
    }
    window.optimizelyFSClient = new OptimizelyFullStackClientSDK(optimizelyClientInstance);
    window.optimizelyFSClient.processQueue();
  });
